<mat-toolbar class="bottom-nav-toolbar">
  <button mat-icon-button aria-label="Karte" [routerLink]="['']">
    <mat-icon>map</mat-icon>
    <span>Karte</span>
  </button>
  <button mat-icon-button aria-label="Suche" [routerLink]="['search']">
    <mat-icon>search</mat-icon>
    <span>Suche</span>
  </button>
  <button mat-icon-button aria-label="Favoriten" [routerLink]="['favorites']">
    <mat-icon>star</mat-icon>
    <span>Favoriten</span>
  </button>
</mat-toolbar>
